import { useEffect, useState } from "react";

import { Box, Grid, TextField } from "@mui/material";

import { Pipeline, Transport } from '../helpers/scripts'

import { getShipements } from '../helpers/requests'

import ModuleShipementPipelineSteps from '../components/ModuleShipementPipelineSteps'

import SearchIcon from '@mui/icons-material/Search';

const Shipments = () => {

    const [shipements, setShipements] = useState([])
    const [transporst, setTransports] = useState({})
    const [searchObj, setSearchObj] = useState({})
    const [filterData, setFilterData] = useState([])
    const [search, setSearch] = useState('')

    const updateTransports = () => {
        const obj = {}
        for (const i in Transport) {
            obj[Transport[i].code] = Transport[i].name
        }
        setTransports({ ...obj })
    }

    const creatSearchObj = (shipements) => {

        let searchObj = {}
        let nSearch = []

        for (const i in shipements) {
            const shipement = shipements[i]
            const order = shipement.order_data[0]
            searchObj[shipement.id] = [ 
                order.user.firstName ? order.user.firstName.toLowerCase() : '', 
                order.user.lastName ? order.user.lastName.toLowerCase() : '', 
                order.user.email ? order.user.email.toLowerCase() : '', 
                order.address.country ? order.address.country.toLowerCase() : '',
                order.source?.name ? order.source?.name.toLowerCase() : '',
                shipement.transport ? shipement.transport.toLowerCase() : '',
                shipement.tracking_id ? shipement.tracking_id.toLowerCase() : ''
            ].join('')
            nSearch.push(shipement.id)
        }
        setSearchObj(searchObj)
        setFilterData(nSearch)
        // console.log(searchObj)
    }


    const updateSerche = async (value) => {

        // await creatSearchObj(shipements)


        if (!value){
            creatSearchObj(shipements)
        }

        setSearch(value.toLowerCase())
        let nSearch = []
        for (const obj in searchObj) {
            if (searchObj[obj].includes(value.toLowerCase())) {
                nSearch.push(obj)
            }
        }
        setFilterData(nSearch)

    }

    useEffect(() => {
        updateTransports()
        
        const st = async () => { 
            const temps = [...await getShipements()]
            creatSearchObj(temps)
            setShipements(temps) 
        }
        
        st()

    },[])



    return (

        <>

            <Box sx={{ mt: 1, mb: 2, display: 'flex', alignItems: 'flex-end' }}>

                <SearchIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                <TextField
                    fullWidth
                    name='search'
                    id='search'
                    value={search}
                    type='search'
                    autoComplete='off'
                    label='Поиск'
                    onChange={(e) => { updateSerche(e.target.value) }}
                    variant="standard"


                />

            </Box>

            <Grid container spacing={2} rowSpacing={1} columnSpacing={2} sx={{}}>

                {shipements.length && filterData.length ? Pipeline.map((step, index) =>

                    <ModuleShipementPipelineSteps key={index} filterData={filterData} stepName={step.name} stepColor={step.color} stepID={step.code} shipements={shipements} transporst={transporst} />

                ) : ''}


            </Grid>
        </>
    );
};
export default Shipments;
